import {
  Component,
  computed,
  EventEmitter,
  inject,
  Input,
  Output,
} from '@angular/core';

import { toSignal } from '@angular/core/rxjs-interop';

import { Store } from '@ngrx/store';

import { User } from '../../../../models/user.model';

import { getCurrentUser, State } from '../../../../store';

import { Navigation } from '../navigation-record/navigation-record.types';

@Component({
  selector: 'app-mobile-nav-panel',

  templateUrl: './mobile-nav-panel.component.html',

  standalone: false,
})
export class MobileNavPanelComponent {
  @Input({ required: true }) rootItems: Navigation.Record[] = [];

  @Input({ required: true }) currentItems: Navigation.Record[] = [];

  @Input({ required: true }) currentTitle = '';

  @Input() stackDepth = 0;

  @Output() rootSelect = new EventEmitter<Navigation.Record>();

  @Output() itemNavigate = new EventEmitter<Navigation.Record>();

  @Output() itemLinkNavigate = new EventEmitter<void>();

  @Output() itemAction = new EventEmitter<string>();

  @Output() backNav = new EventEmitter<void>();

  @Output() closeNav = new EventEmitter<void>();

  isActiveRoot(item: Navigation.Record): boolean {
    return (item.label || item.alias) === this.currentTitle;
  }

  private readonly store = inject(Store<State>);

  readonly user = toSignal<User>(this.store.select(getCurrentUser));

  readonly accountName = computed<string>(() => {
    const user = this.user();

    return user?.Account?.Name ?? '';
  });

  readonly billingAddress = computed<string>(() => {
    const user = this.user();

    if (!user?.Account?.BillingAddress) return '';

    const { street, city, stateCode, postalCode } = user.Account
      .BillingAddress as Record<string, string>;

    return `${street ?? ''}\r\n${city ?? ''}, ${stateCode ?? ''} ${postalCode ?? ''}`;
  });
}

